<template>
  <div
    class="meeting-info"
    v-show="
      seminarInfo &&
      (extraItem.extras('activityTheme.display') == 1 ||
        extraItem.extras('activityTime.display') == 1 ||
        extraItem.extras('activityPlace.display') == 1 ||
        extraItem.extras('activitySchedule.display') == 1)
    "
  >
    <ul>
      <li
        class="meeting-item"
        :style="{
          display:
            extraItem.extras('activityTheme.display') == 1 ? 'block' : 'none',
        }"
      >
        <h5 class="item-title"><i class="icon icontemp theme"></i>活动主题</h5>
        <div class="item-desc">{{ seminarInfo.title }}</div>
      </li>
      <li
        class="meeting-item"
        :style="{
          display:
            extraItem.extras('activityTime.display') == 1 ? 'block' : 'none',
        }"
      >
        <h5 class="item-title"><i class="icon icontemp time1"></i>活动时间</h5>
        <div
          class="item-desc"
          v-if="seminarInfo.startTime && seminarInfo.startTime != 0"
        >
          {{ (seminarInfo.startTime * 1000) | dateFormat }} ～
          {{ (seminarInfo.endTime * 1000) | dateFormat }}
        </div>
      </li>
      <li
        class="meeting-item"
        :style="{
          display:
            extraItem.extras('activityPlace.display') == 1 ? 'block' : 'none',
        }"
      >
        <h5 class="item-title"><i class="icon icontemp place2"></i>活动地点</h5>
        <div class="item-desc">{{ seminarInfo.address }}</div>
      </li>
      <li
        class="meeting-item"
        :style="{
          display:
            extraItem.extras('activitySchedule.display') == 1
              ? 'block'
              : 'none',
        }"
      >
        <h5 class="item-title">
          <i class="icon icontemp range-time"></i>活动日程
        </h5>
        <dl
          class="item-schedule"
          v-for="(agenda, index) in seminarInfo.agendas"
          :key="index"
        >
          <dt class="item-date">
            {{ (agenda.agendaDate * 1000) | dateFormat("MM月DD日") }}
          </dt>
          <dd
            class="item-time-info"
            v-for="item in agenda.items"
            :key="item.agendaId"
          >
            <div class="item-time">
              <div class="item-circle"></div>
              {{ (item.startTime * 1000) | dateFormat("HH:mm") }}-{{
                (item.endTime * 1000) | dateFormat("HH:mm")
              }}
              <!--<div class="item-split"></div>-->
            </div>
            <div class="item-guest-info">
              <div class="item-guest-name">{{ item.name }}</div>
              <div v-for="guest in item.guests" :key="guest.seminarGuestId">
                <div class="item-guest-post">
                  {{ guest.name }} {{ guest.enterprise }}
                  {{ guest.demartment }} {{ guest.duty }}
                </div>
              </div>
            </div>
          </dd>
        </dl>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Metting",
  props: ["seminarInfo"],
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
};
</script>
